const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://royaltech.docr.online';

if (import.meta.env.DEV) {
  console.log('API_BASE_URL:', API_BASE_URL);
  console.log('VITE_API_URL env var:', import.meta.env.VITE_API_URL || 'NOT SET (using default)');
}

export default API_BASE_URL;

export const apiUrl = (path: string) => `${API_BASE_URL}${path}`;
export const getApiUrl = (path: string) => `${API_BASE_URL}${path}`;
